import { render, staticRenderFns } from "./appoint.vue?vue&type=template&id=405c21ba&scoped=true&"
import script from "./appoint.vue?vue&type=script&lang=js&"
export * from "./appoint.vue?vue&type=script&lang=js&"
import style0 from "./appoint.vue?vue&type=style&index=0&id=405c21ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405c21ba",
  null
  
)

export default component.exports